// extracted by mini-css-extract-plugin
export default {"image":"fX-z","loaded":"gX-z"};